// extracted by mini-css-extract-plugin
module.exports = {"question":"collapseBox_question__9SAYN","titleQuestion":"collapseBox_titleQuestion__kHeM1","answer":"collapseBox_answer__m91rD"};